import { style, styleVariants } from "@vanilla-extract/css";

import { vars } from "~/styles/tokens.css";

const pressedRing = `inset 0 0 0 1px ${vars.color.primary}`;

const base = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space["2xs"],
  width: "100%",
  padding: vars.space.sm,
  textAlign: "left",
  font: "inherit",
  color: vars.color.textDefault,
  backgroundColor: vars.color.surface,
  borderRadius: vars.radius.md,
  borderWidth: "1px",
  cursor: "pointer",
  outline: "none",
  transitionProperty: "background-color, border-color",
  transitionDuration: vars.motion.fast,
  transitionTimingFunction: vars.motion.easing,
  selectors: {
    "&:hover:not(:disabled)": {
      backgroundColor: vars.color.secondaryHover,
    },
    "&:focus-visible": {
      boxShadow: vars.shadow.focus,
    },
    "&[aria-pressed='true']": {
      borderColor: vars.color.primary,
      boxShadow: pressedRing,
    },
    "&[aria-pressed='true']:focus-visible": {
      boxShadow: `${pressedRing}, ${vars.shadow.focus}`,
    },
    "&:disabled": {
      cursor: "not-allowed",
      opacity: 0.6,
    },
  },
});

export const tile = styleVariants({
  solid: [
    base,
    {
      borderStyle: "solid",
      borderColor: vars.color.borderSubtle,
    },
  ],
  dashed: [
    base,
    {
      borderStyle: "dashed",
      borderColor: vars.color.borderStrong,
    },
  ],
});
